import api from '@pray/shared/utils/api';

export type GetAcquisitionSummaryParams = {
  artistId: string;
  startDate?: string;
  endDate?: string;
  daysSince?: string;
  dateGranularity?: string;
  dimensionSelect?: string;
  spendCategory?: string;
  platform?: string;
  cohortType?: string;
  countryTier?: string;
  subStatus?: string;
  campaignIds?: string[];
  bustCache?: boolean;
};

export const getAcquisitionSummary = async ({
  artistId,
  startDate,
  endDate,
  daysSince,
  dateGranularity,
  dimensionSelect,
  spendCategory,
  platform,
  cohortType,
  countryTier,
  subStatus,
  campaignIds,
  bustCache,
}: GetAcquisitionSummaryParams) => {
  const params: Record<string, string> = {};

  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (daysSince) params.daysSince = daysSince;
  if (dateGranularity) params.dateGranularity = dateGranularity;
  if (dimensionSelect) params.dimensionSelect = dimensionSelect;
  if (spendCategory) params.spendCategory = spendCategory;
  if (platform) params.platform = platform;
  if (cohortType) params.cohortType = cohortType;
  if (countryTier) params.countryTier = countryTier;
  if (subStatus) params.subStatus = subStatus;
  if (campaignIds?.length) params.campaignIds = campaignIds.join(',');
  if (bustCache) params.bustCache = 'true';

  const url = `/web/studio/artists/${artistId}/analytics/acquisition`;
  const response = await api.executeGetRequest(url, params);

  return (response.data as any)?.data;
};
